module.exports = __webpack_public_path__ + "img/menuimg2.2fa269fd.png";